export const endpoints = Object.freeze({
  jwtValidate: '/showcase/api/v1/jwt/validate',
});
